const routes = {
  HOME: "/",
  SETTINGS: "/settings",
  RESULTS: "/results",
  NOT_FOUND: "/404",
};

export default routes;
